import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
import { bansApi } from './api';
export const useBansByUser = (initialParams) => usePaginatedEndpoint({
    endpoint: bansApi.getBansByUser,
    itemsSelector: ({ bans }) => bans,
    totalSelector: ({ number_of_users }) => number_of_users,
    initialParams,
});
